<template>
  <header>
    <div class="header-grid">
      <div class="header-grid__row align-items-center header-content">
        <div class="col">
          <div class="row justify-between" style="color: #fff">
            <div class="col-14"><a href="/">
              <img class="logo" src="../../assets/iPro_logo.png" alt="iPro Logo"/>
              <h1 class="sr-only">iPro Systems, LLC. - {{subDomain}} Management</h1></a>
            </div>
            <div class="col text-right right-bar">|</div>
          </div>
        </div>
        <div class="col text-left" v-if="user">
          Hi, {{ user.signInUserSession.idToken.payload.given_name || 'Customer' }}
        </div>
        <div class="col" v-if="user">
        </div>
        <div class="appButton--container" v-if="user">
          <div class="appMenu--container">
            <font-awesome-icon :icon=" ['fas', 'th']" @click.stop="showApps()" class="menuToggle"></font-awesome-icon>
            <div class="notch" v-show="appMenu"></div>
          </div>
          <div class="appMenu--apps" id="appNav" tabindex="-1" v-show="appMenu" @mousedown.prevent="followLink" @blur="blur">
            <ul>
              <li>
                <a :href="`${accountLink}`">
                  <font-awesome-icon :icon=" ['fas', 'users-cog']"></font-awesome-icon>
                  <span class="route-location">Accounts</span>
                </a>
              </li>
              <li>
                <a :href="`${admanLink}`">
                  <font-awesome-icon :icon=" ['fas', 'ad']"></font-awesome-icon>
                  <span class="route-location">AdMan</span>
                </a>
              </li>
              <li>
                <a :href="`${admanDevLink}`">
                  <font-awesome-icon :icon=" ['fas', 'code']"></font-awesome-icon>
                  <span class="route-location">AdMan-Dev</span>
                </a>
              </li>
              <li>
                <a :href="`${itemsLink}`">
                  <font-awesome-icon :icon=" ['fas', 'barcode']"></font-awesome-icon>
                  <span class="route-location">Items</span>
                </a>
              </li>
              <li>
                <a :href="`${customerLink}`">
                  <font-awesome-icon :icon=" ['fas', 'address-book']"></font-awesome-icon>
                  <span class="route-location">Customers</span>
                </a>
              </li>
              <li>
                <a :href="`${promosLink}`">
                  <font-awesome-icon :icon=" ['fas', 'tag']"></font-awesome-icon>
                  <span class="route-location">Promotions</span>
                </a>
              </li>
              <li>
                <a :href="`${pmepLink}`">
                  <font-awesome-icon :icon=" ['fas', 'project-diagram']"></font-awesome-icon>
                  <span class="route-location">PMEP</span>
                </a>
              </li>
              <li>
                <a :href="`${pmepDevLink}`">
                  <font-awesome-icon :icon=" ['fas', 'code']"></font-awesome-icon>
                  <span class="route-location">PMEP Dev</span>
                </a>
              </li>
            </ul>
          </div>
          <a class="profile" :href="`${profileLink}` + '/profile'"><font-awesome-icon :icon=" ['fas', 'user-circle']"></font-awesome-icon></a>
          <a @click.prevent="logout()">Sign Out</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { store } from '@/store/index'
import Multiselect from 'vue-multiselect'

export default {
  name: 'headerComponent',
  data () {
    return {
      globalSearch: '',
      appMenu: false,
      readyToSearch: false,
      results: '',
      searchOption: 'All',
      accountLink: '',
      customerLink: '',
      itemsLink: '',
      profileLink: '',
      promosLink: '',
      billingLink: '',
      reportingLink: '',
      admanLink: '',
      admanDevLink: '',
      pmepLink: '',
      pmepDevLink: ''
    }
  },
  props: [
    'subDomain',
    'searchOptions'
  ],
  components: {
    'Multiselect': Multiselect
  },
  mounted: function () {
    let self = this
    if (this.$route.query.length >= 1) {
      self.globalSearch = self.$route.query.q
      self.searchOption = self.$route.query.search_by
      self.readyToSearch = true
    }
    this.accountLink = process.env.ACCOUNT_LOC
    this.customerLink = process.env.CUSTOMERS_LOC
    this.itemsLink = process.env.ITEMS_LOC
    this.profileLink = process.env.ACCOUNT_LOC
    this.promosLink = process.env.PROMOS_LOC
    this.billingLink = process.env.BILLING_LOC
    this.admanLink = process.env.ADMAN_LOC
    this.admanDevLink = process.env.ADMAN_DEV_LOC
    this.pmepLink = process.env.PMEP_LOC
    this.pmepDevLink = process.env.PMEP_DEV_LOC
  },
  computed: {
    user () {
      if (!store.state.user || Object.keys(store.state.user).length === 0) {
        return false
      } else if (store.state.user.hasOwnProperty('signInUserSession') && !store.state.user.signInUserSession) {
        return false
      } else {
        return store.state.user
      }
    },
    userGroup () {
      if (!store.state.user || Object.keys(store.state.user).length === 0) {
        return false
      } else if (store.state.user.hasOwnProperty('signInUserSession') && !store.state.user.signInUserSession) {
        return false
      } else {
        return store.state.user.signInUserSession.accessToken.payload['cognito:groups']
      }
    },
    searchFilter () {
      if (this.searchOptions) {
        return this.searchOptions
      } else {
        return []
      }
    },
    showMenu () {
      if (this.$route.meta.app === 'promos' || this.$route.meta.app === 'items') {
        return false
      } else {
        return window.location.href === (this.accountLink + this.$route.path)
      }
    }
  },
  methods: {
    followLink (event) {

    },
    blur () {
      this.appMenu = false
    },
    logout () {
      window.location.href = process.env.SIGNOUT_LOCATION
    },
    showApps () {
      this.appMenu = !this.appMenu
      if (this.appMenu === true) {
        setTimeout(function () {
          document.getElementById('appNav').focus()
        }, 100)
      }
    },
    closeAppsMenu () {
      this.appMenu = false
    },
    showSubmit () {
      if (this.globalSearch.length >= 1) {
        this.readyToSearch = true
      } else {
        this.readyToSearch = false
      }
    },
    submitSearch () {
      let self = this
      self.$router.push({name: 'search', query: { search_by: self.searchOption, q: self.globalSearch }})
      this.$root.$emit('search', true)
    },
    clickOutsideTrigger: function (event) {
      this.appMenu = false
    }
  }
}
</script>

<style lang="less">
  @import '../../less/elements/color.less';
  @import '../../less/elements/typography.less';
  header{
    background: #005270;
    height: 46px;
    width: 100%;
    color: #fff;
    z-index: 5;
    position: relative;
    .header-content{
      height: 46px;
      .font-family();
      font-size: 20px;
      font-weight: 600;
      max-width: 1380px;
    }
    &.accounts {
      background: @color-header;
    }
    &.customers-app {
      background: #730400;
    }
    &.items-app {
      background: #005E02;
    }
  }
  .logo{
    width: 70px;
    margin-left: 100px;
    fill: #fff !important;
    svg{
      height: 100%;
      width: 100%;
    }
  }
  .header-grid__row{
    display: grid;
    grid-column-gap: 16px;
    grid-template-columns: minmax(262px, 12.5%) 2fr 4fr 2fr;
  }
  .right-bar{
    margin-right: -1rem;
  }
  .menuToggle{
    position: relative;
  }
  .search__global{
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .search-items__button{
    position: absolute;
    white-space: nowrap;
    right: 1rem;
  }
  .appButton--container{
    display: flex;
    justify-content: space-between;
    margin-right: 1rem;
    align-items: center;
    position: relative;
    right: 0px;
    width: 200px;
    padding: 0 1rem;
    margin-left: auto;
    height: 46px;
    .profile {
      color: #fff;
      transition: .3s ease-in-out;
      &:hover {
        color: darken(#fff, 40%);
      }
    }
    a:not([href]):not([tabindex]):hover{
      color: darken(#fff, 40%);
    }
  }
  .notch{
    border-color: transparent;
    border-bottom-color: #fff;
    border-style: dashed dashed solid;
    border-width: 0 10px 10px;
    position: absolute;
    left: 0;
    top: 29px;
    z-index: 8;
  }
  .appMenu {
    &--container{
      display: inline-block;
      position: relative;
      transition: .3s ease-in-out;
      &:hover {
        color: darken(#fff, 40%);
      }
    }
    &--apps{
      height: 325px;
      width: 300px;
      border: 1px solid #707070;
      position: absolute;
      top: 44px;
      background: #fff;
      z-index: 2;
      right: 1rem;
      border-radius: 3px;
      box-sizing: content-box;
      overflow-y: scroll;
      box-shadow: 0px 3px 6px rgba(0,0,0,0.26);
      z-index: 7;
       ul {
        display: flex;
        flex-flow: row wrap;
        padding: 15px;
        li{
          text-align: center;
          width: 33.333%;
          height: 100px;
        }
      }
      a{
        color: @color-text;
        text-align: center;
        padding: 5px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        svg{
          width: 2rem !important;
          height: 2rem !important;
          path {
            fill: @color-text;
          }
        }
        &:hover{
          text-decoration: none;
          border: 1px solid @color-border;
        }
      }
      .route-location{
        font-size: .7rem;
        font-weight: 300;
        display: block;
      }
    }

  }
</style>
<style lang="less" scoped>
  .multiselect__input,
  .multiselect__single {
    line-height: 1;
    height: 100;
  }
</style>



// WEBPACK FOOTER //
// src/components/foundation/header.vue